import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_URL } from '../consts';
import {
  IGetCardDataResponse,
  IGetCardsByCategorySlugRequest,
  IGetCardsByCategorySlugResponse,
} from '../types';

export const cardsAPI = createApi({
  reducerPath: 'cardsAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL + '/api/v2/client',
  }),
  endpoints: (build) => ({
    getCard: build.query<IGetCardDataResponse, string>({
      query: (id) => ({
        url: `/data/cards/${id}`,
        method: 'get',
      }),
    }),

    getCardsByCategorySlug: build.query<
      IGetCardsByCategorySlugResponse,
      IGetCardsByCategorySlugRequest
    >({
      query: ({ slug, page, limit }) => ({
        url: `/data/cards/category/${slug}`,
        method: 'get',
        params: { page, limit },
      }),
      serializeQueryArgs: ({ queryArgs }) => {
        const { page, ...rest } = queryArgs;

        return rest;
      },
      merge: (currentCache, newItems) => {
        if (currentCache) {
          return {
            data: [...currentCache.data, ...newItems.data],
            meta: newItems.meta,
          };
        }

        return newItems;
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg;
      },
    }),
  }),
});

export const {
  useGetCardQuery,
  useLazyGetCardQuery,
  useGetCardsByCategorySlugQuery,
  useLazyGetCardsByCategorySlugQuery,
} = cardsAPI;

export const { getCard, getCardsByCategorySlug } = cardsAPI.endpoints;
